/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { VerifyEmailRequestDto, VerifyEmailResponseDto } from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class Common<SecurityDataType = unknown> {
	http: HttpClient<SecurityDataType>;

	constructor(http: HttpClient<SecurityDataType>) {
		this.http = http;
	}

	/**
	 * @description 이메일 인증 확인
	 *
	 * @tags /common
	 * @name DoPostCommonVerifyEmail
	 * @summary 이메일 인증 확인 (인증 없음)
	 * @request POST:/common/verify/email
	 * @secure
	 * @response `200` `VerifyEmailResponseDto` OK
	 * @response `400` `VerifyEmailResponseDto` 토큰 만료
	 * @response `500` `VerifyEmailResponseDto` 서버 오류
	 */
	doPostCommonVerifyEmail = (data: VerifyEmailRequestDto, params: RequestParams = {}) =>
		this.http.request<VerifyEmailResponseDto, VerifyEmailResponseDto>({
			path: `/common/verify/email`,
			method: "POST",
			body: data,
			secure: true,
			type: ContentType.Json,
			format: "json",
			...params,
		});
}
